import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { debounce } from 'lodash';

import { Button, ErrorToast, Search } from 'components';
import DepartmentManagement_Table from './DepartmentManagement_Table';
import DepartmentManagement_Modal from './DepartmentManagement_Modal';

import { setUserRights, setUserDepartments } from 'redux/generalState.actions';
import DepartmentService from 'api/department'

import './departmentManagement.scss';

const DepartmentManagement = ({}) => {
  const userInfo = useSelector((state) => state.general.user);
  const dispatch = useDispatch();

    const [isDeptCreateToggled, setDeptCreateToggle] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [editDept, setEditDept] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [isSearching, setIsSearching] = useState(false);

    useEffect(() => {
        fetchDepartments()
    }, [])
    
    useEffect(() => {
        if(!isDeptCreateToggled) setEditDept(null);
    }, [isDeptCreateToggled])

    // const fetchDepartments = async () => {
    //     try {
    //         const {data: { data }} = await DepartmentService.getAll({});
    //         setDepartments(data);
    //     } catch(error) {
    //         toast.error(<ErrorToast error={error} />);
    //     }
    // }

    const fetchDepartments = async (search='') => {
        try {
          setIsSearching(true);
          const filter = {filters: {}, search};
    
          const {
            data: { data },
          } = await DepartmentService.getAll(filter);
          dispatch(setUserDepartments(data));
          setDepartments(data);
        } catch (error) {
          dispatch(setUserDepartments([]));
          dispatch(setUserRights({}));
          toast.error(<ErrorToast error={error} />);
        } finally {
          setIsSearching(false);
        }
      };
    
    const onCreateNew = () => {
        setDeptCreateToggle(true);
    }

    const onSearchChange = async (value) => {
      setSearchValue(value);
      handleSearch(value);
    };

    const handleSearch = useCallback(
      debounce((search) => fetchDepartments(search), 500),
      []
    );
   
  return (
    <div className='dept-manag'>
        {isDeptCreateToggled && <DepartmentManagement_Modal toggleModal={setDeptCreateToggle} isModalToggled={isDeptCreateToggled} fetchData={fetchDepartments} editDept={editDept} />}
        {userInfo?.metadata?.role === 'admin' && (
            <div className="client-det-f__buttons-wrapper" style={{ marginBottom: '10px', justifyContent: 'flex-end' }}>
               <Search
                    isLoading={isSearching}
                    size="medium"
                    border
                    value={searchValue}
                    dropdown={false}
                    onSearchChange={(e, { value }) => onSearchChange(value)}
                    isFilter={true}
                    placeholder="Search"
                  />
                <Button
                type="submit"
                color="blue"
                size="fluid"
                onClick={onCreateNew}
                >
                    Create new department
                </Button>
            </div>
        )}
        <DepartmentManagement_Table filteredData={departments} setDeptCreateToggle={setDeptCreateToggle} setEditDept={setEditDept} fetchData={fetchDepartments} />
        
   </div>
  );
};

export default DepartmentManagement;
